<script lang="ts">
  import type { PrStore } from '../lib/state/pr.svelte';
  import { prPath } from '../lib/router';
  import { carryFilter } from '../lib/logic/filefilter';
  import { relTime } from '../lib/logic/time';
  import { nav } from '../lib/nav.svelte';

  interface Props {
    pr: PrStore;
  }
  let { pr }: Props = $props();

  const head = $derived(pr.pr!.headRefOid);
  const snaps = $derived(pr.snapshots);
  let from = $state('base');
  let to = $state('');
  $effect(() => {
    if (!to) to = head;
  });
  const filesPath = $derived(prPath(pr.owner, pr.repo, pr.number, 'files'));

  function href(f: string, t: string): string {
    const q = new URLSearchParams();
    if (f !== 'base') q.set('from', f);
    if (t !== head) q.set('to', t);
    const s = q.toString();
    return carryFilter(filesPath + (s ? '?' + s : ''), nav.query);
  }

  const valid = $derived(from !== to);
</script>

<section class="snapshots">
  <div class="sectionhead">
    <div>
      <h2 class="section-title">Snapshots</h2>
      <p class="muted small">
        Every head the pull request pointed at. Pick two to see the interdiff, computed from the files themselves so
        rebases don't drown it in upstream changes.
      </p>
    </div>
    <div class="compare-bar">
      <span class="mono small">{from === 'base' ? 'base' : from.slice(0, 7)} → {to === head ? 'head' : to.slice(0, 7)}</span>
      <button class="btn primary" disabled={!valid} onclick={() => nav.go(href(from, to))}>Compare</button>
    </div>
  </div>
  <div class="snap-table" role="table" aria-label="Snapshots">
    <div class="snap-row head" role="row">
      <span role="columnheader">From</span><span role="columnheader">To</span><span role="columnheader">Snapshot</span><span role="columnheader"></span>
    </div>
    <div class="snap-row" role="row">
      <span role="cell"><input type="radio" name="from" value="base" bind:group={from} aria-label="Compare from base" /></span>
      <span role="cell"></span>
      <span role="cell" class="snap-main"><b>Base</b> <span class="muted">{pr.pr!.baseRefName} (merge base)</span></span>
      <span role="cell"></span>
    </div>
    {#each snaps as s, i (s.sha)}
      <div class="snap-row" role="row" class:current={s.sha === head}>
        <span role="cell"><input type="radio" name="from" value={s.sha} bind:group={from} aria-label="Compare from {s.short}" /></span>
        <span role="cell"><input type="radio" name="to" value={s.sha} bind:group={to} aria-label="Compare to {s.short}" /></span>
        <span role="cell" class="snap-main">
          <b class="snap-n" title="Snapshot {s.n}">{s.n}</b>
          <code>{s.short}</code>
          <span class="snap-label">{s.label}</span>
          <span class="muted small">
            {s.kind === 'force-push' ? 'force-push' : s.kind === 'replaced' ? 'replaced by a force-push' : 'commit'}{s.actor ? ' · ' + s.actor : ''}{s.at ? ' · ' + relTime(s.at) : ''}{s.sha === head ? ' · head' : ''}
          </span>
        </span>
        <span role="cell" class="snap-links">
          <a href={href('base', s.sha)}>Diff</a>
          {#if i > 0}<a href={href(snaps[i - 1].sha, s.sha)}>Since previous</a>{/if}
          {#if s.sha !== head}<a href={href(s.sha, head)}>Since this</a>{/if}
        </span>
      </div>
    {/each}
  </div>
</section>
